import { service } from '../../../../helpers/http' 

export const ActionIndexOccurrenceSheetSchedules = ({ dispatch }, payload) => {

    return service({
        module: 'domainTimeSheet',
        action: 'indexOccurrenceSheetSchedules',
        payload: payload
    })
    
}

export const ActionCreateOccurrenceSheetSchedule = ({ dispatch }, payload) => {
    
    return service({
        module: 'domainTimeSheet',
        action: 'createOccurrenceSheetSchedule',
        payload: payload
    })
    
}

export const ActionUpdateOccurrenceSheetSchedule = ({ dispatch }, payload) => {
    
    return service({
        module: 'domainTimeSheet',
        action: 'updateOccurrenceSheetSchedule',
        payload: payload
    })
}

export const ActionDeleteOccurrenceSheetSchedule = ({ dispatch }, payload) => {
    
    return service({
        module: 'domainTimeSheet',
        action: 'deleteOccurrenceSheetSchedule',
        payload: payload
    })
    
}

export const ActionIndexOccurrenceSheetScheduleTypes = ({ dispatch }, payload) => {

    return service({
        module: 'domainTimeSheet',
        action: 'indexOccurrenceSheetScheduleTypes',
        payload: payload
    })
    
}
